<template>
  <v-app>
      <v-app-bar app color="#0891c2" flat dark clipped-left>
        <v-toolbar-title class="headline">
          <span class="resman-title">ResMan</span>
          <span class="font-weight-light">Authentication Manager</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <span class="font-weight-light" v-on:tokenExpiring.native="promptTokenExpiring">{{ loggedInUser }}</span>
        <nav-menu
          @signOut="signOut">
        </nav-menu>
      </v-app-bar>
      <nav-drawer>
      </nav-drawer>
      <v-main>
        <v-container fluid>
          <router-view></router-view>
        </v-container>
      </v-main>
  </v-app>
</template>

<script>
import NavMenu from './components/Nav/Menu';
import NavDrawer from './components/Nav/Drawer';

export default {
  name: 'App',
  components: {
    NavMenu,
    NavDrawer
  },
  data: () => ({
    autoRefresh: false,
    showExpiringWarning: false
  }),
  methods: {
    signOut () {
      this.$auth.signOut()
    },
  },
  computed: {
    loggedInUser () {
      if (this.$auth.isAuthenticated()) {
        return `${this.$auth.getCurrentAccount().name} - ${this.$auth.getCurrentAccount().username}`
      }
      return null
    },
  },
  async created () {
    if (this.$auth.isAuthenticated() === false) {
      await this.$auth.signIn();
    }
  }
}
</script>

<style>
@import "./assets/css/fonts.scss";

.resman-title {
  font-family: Whitney;
  font-size: 26px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  margin-left: 5px;
}
</style>
